/* eslint-disable import/prefer-default-export */
export const SELECT_CATEGORY = 'Please select a category';
export const SELECT_TYPE = 'Please select a type';
export const SELECT_GENDER = 'Please select a gender';
